// extracted by mini-css-extract-plugin
module.exports = {"bgTrans":"BgTrans_bgTrans__1Veo5"};